import { jsx as _jsx } from "react/jsx-runtime";
import { VENTURE_STATUS_LABELS } from "../model/constants";
/**
 * Badge component for displaying venture status with appropriate styling
 *
 * Requirements:
 * - 2.1: Display venture status with visual distinction
 * - 4.1: Show status in venture displays
 * - 9.2: Display status in public venture listings
 * - 12.2: Show status prominently
 * - 12.4: Display status in filtered views
 */
export const VentureStatusBadge = ({ status, size = "md", className = "", }) => {
    // Status-based color schemes following black/white theme with minimal accents
    const getStatusColor = () => {
        switch (status) {
            case "draft":
                return "bg-gray-100 text-gray-800 border-gray-300";
            case "live":
                return "bg-black text-white border-black";
            case "successful":
                return "bg-green-100 text-green-800 border-green-300";
            case "failed":
                return "bg-red-100 text-red-800 border-red-300";
            case "converted":
                return "bg-blue-100 text-blue-800 border-blue-300";
            default:
                return "bg-gray-100 text-gray-800 border-gray-300";
        }
    };
    // Mobile-friendly sizing with adequate touch targets
    const sizeClasses = {
        sm: "px-2 py-1 text-xs min-h-[32px]",
        md: "px-2.5 py-1.5 text-sm min-h-[36px]",
        lg: "px-3 py-2 text-base min-h-[44px]",
    };
    const label = VENTURE_STATUS_LABELS[status];
    const colorClasses = getStatusColor();
    return (_jsx("span", { className: `inline-flex items-center justify-center rounded-full font-medium border ${sizeClasses[size]} ${colorClasses} ${className}`, role: "status", "aria-label": `Venture status: ${label}`, children: label }));
};
